import { Grid, Typography } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import summaryStyles from '../summarySection/SummaryStyles';
import SummaryAdditionalDetailsLink from '../summaryAdditionalDetailsLink/SummaryAdditionalDetailsLink';
import Translation from '../../../../../../common/components/translation/Translation';
import useCustomizeCarContext from '../../../../../hooks/useCustomizeCarContext';

export interface ISummaryTitleProps {
  setIsExpanded: (value: boolean) => void;
  isExpanded: boolean;
}

const SummaryTitle: FunctionComponent<ISummaryTitleProps> = ({ isExpanded, setIsExpanded }) => {
  const styles = summaryStyles();
  const { selectedCar } = useCustomizeCarContext();
  const shouldDisplayDetailsLink = !!selectedCar?.selectedFeatures.selected.length;

  return (
    <Grid container={true} className={styles.containerTitle}>
      <Typography variant="sectionTitle" className={styles.sectionTitle}>
        <Translation id={'trans__configurator__customise_page_summary_section__section_title'} />
      </Typography>
      {shouldDisplayDetailsLink && (
        <SummaryAdditionalDetailsLink setIsExpanded={setIsExpanded} isExpanded={isExpanded} />
      )}
    </Grid>
  );
};

export default SummaryTitle;
